export const SearchList = "SearchList";
export const SearchListItem = `${SearchList}__Item`;
export const SearchListItemSelected = `${SearchList}__Item--selected`;
export const SearchListEmptyMessage = `${SearchList}__EmptyMessage`;
